// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3xnKq","inner":"Form_inner__2vNJx","range":"Form_range__2n6Bi","name":"Form_name__2cACg","actions":"Form_actions__AJmx9"};